import React from 'react';

import PropTypes from 'prop-types';

import { ContactPersonItem } from 'components/ExpertSearch/components/ContactPersonItem/ContactPersonItem';
import { NetworkConnectionSubtitle } from 'components/ExpertSearch/components/NetworkConnectionSubtitle/NetworkConnectionSubtitle';
import { flatCards } from 'components/ExpertSearch/components/card-utils';

import './NetworkConnectionSection.scss';

export const NetworkConnectionSection = ({ data }) => {
  const cards = flatCards(data?.cards || []);

  return (
    <div className="networkConnectionSection">
      <NetworkConnectionSubtitle
        description={data?.description}
        descriptionEmail={data?.descriptionEmail}
        descriptionAfterEmail={data?.descriptionAfterEmail}
      />

      <div className="networkConnectionSectionContactPersonContainer">
        {cards.map((details, index) => (
          <div
            key={index}
            className={`networkConnectionSectionContactPersonItem${
              !details?.title ? ' borderNone' : ''
            }`}>
            <ContactPersonItem
              title={details?.title}
              name={details.name}
              phoneNumber={details.phoneNumber}
              phoneNumberDisplay={details.phoneNumberDisplay}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

NetworkConnectionSection.propTypes = {
  data: PropTypes.shape({
    description: PropTypes.string,
    descriptionEmail: PropTypes.string,
    descriptionAfterEmail: PropTypes.string,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        name: PropTypes.string,
        phoneNumber: PropTypes.string,
        phoneNumberDisplay: PropTypes.string,
      })
    ),
  }),
};

NetworkConnectionSection.defaultProps = {
  data: {
    description: '',
    descriptionEmail: '',
    descriptionAfterEmail: '',
    cards: [],
  },
};
